module.exports = __webpack_public_path__ + "img/7.67e6a5d1.jpg";